var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsColorgrading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 44.476,
    viewBox: "0 0 46 44.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "skills_colorgrading",
    d: "M8.108,45.758l-1.315-.4a4.394,4.394,0,0,1-2.486-2.743,4.605,4.605,0,0,1,.371-3.829l3.429-7.773Zm10.63,4.458a4.683,4.683,0,0,1-4.686-4.687V33.7L19.31,48.673a2.54,2.54,0,0,0,.343.8,7.857,7.857,0,0,0,.572.743Zm10.745-1.372a2.718,2.718,0,0,1-2.515-.229,4.287,4.287,0,0,1-1.886-2.057L14.166,16.9a2.79,2.79,0,0,1,.114-2.572A4.014,4.014,0,0,1,16.395,12.5L34.569,5.923a3.057,3.057,0,0,1,2.572.229A4.034,4.034,0,0,1,38.97,8.209L49.886,37.528a4.166,4.166,0,0,1-.171,2.8,3.27,3.27,0,0,1-2,1.886ZM24.8,20.554a1.758,1.758,0,1,0-1.2-.514A1.645,1.645,0,0,0,24.8,20.554Z",
    transform: "translate(-4.051 -5.74)",
    fill: "#5637fa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsColorgrading);
export default __webpack_public_path__ + "static/media/skills_colorgrading.20ae4d64f2887651c8c705be99274de7.svg";
export { ForwardRef as ReactComponent };